import { useEffect, useState } from "react";
import { Drawer } from "antd";
import { useLocation } from "react-router-dom";
import GlobalChat from "../../../components/One-to-one-games/Duels-global-chat/GlobalChat";
import "./GlobalChatWrapper.scss";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const GlobalChatWrapper = () => {
  const { t, i18n } = useTranslation("common");
  const location = useLocation();
  const isRTL = i18n.language === "ar";
  const [open, setOpen] = useState(true); // default open
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const isLogin = useSelector((state) => state.login.isLogin);
  const hideOnMessagesPage = location.pathname === "/messages";

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  if (!isLogin || hideOnMessagesPage) {
    return null;
  }

  return (
      <>
        {/* ── Floating open tab — visible only when drawer is closed ── */}
        {!open && (
          <div className="chat-open-tab" onClick={() => setOpen(true)}>
            <span className="chat-open-arrow">
              {isRTL ? "\u276F" : "\u276E"}
            </span>
          </div>
        )}

        {/* ── Drawer ── */}
        <Drawer
          title={null}
          placement={isRTL ? "left" : "right"}
          open={open}
          onClose={() => setOpen(false)}
          width={450}
          closable={false}          /* hide default close — we use our own */
          className="global-chat-drawer"
          styles={{
            body: { padding: 0 },
            content: { padding: 0 },
            mask: { background: "transparent" }, /* no dark overlay */
          }}
        >
          <GlobalChat
            isGlobal
            setChatIsVisible={() => setOpen(false)}
            isMobile={isMobile}
          />
          {/* After chat so this sits above the full-bleed panel and receives clicks */}
          <button
            type="button"
            className="drawer-close-tab"
            aria-label={t("one_to_one.close_global_chat")}
            title={t("one_to_one.close_global_chat")}
            onClick={(e) => {
              e.stopPropagation();
              setOpen(false);
            }}
          >
            <span className="drawer-close-arrow" aria-hidden="true">
              {isRTL ? "\u276E" : "\u276F"}
            </span>
          </button>
        </Drawer>
      </>
  );
};

export default GlobalChatWrapper;